import { AuthAPI } from "../../APIs/AuthAPI";
import { Action } from "../../Utilities/Action";
import { AuthorizationError } from "../../Utilities/Errors/AuthorizationError";

class UserManager {
  public readonly onuserloggedin: Action<void>;
  public readonly onuserloggedout: Action<void>;

  private _username: string | undefined;

  constructor() {
    this.onuserloggedin = new Action();
    this.onuserloggedout = new Action();
  }

  public async init() {
    let username = await AuthAPI.getUsername();
    if (username) {
      this._username = username;
    }
    if (this.isLoggedIn) {
      this.onuserloggedin.invoke();
    }
  }

  public login() {
    window.location.href = '/api/auth/login';
  }

  public logout() {
    window.location.href = '/api/auth/logout';
  }

  public get isLoggedIn() {
    return !!this._username;
  }

  public get username(): string {
    return this._username ?? "";
  }
}

const instance = new UserManager();
export { instance as UserManager }